export default __webpack_public_path__ + "static/studycafe-firenze4-c4534d3020e2727414102549a5dc7d85.png";